import { PageHero, CtaBlock, TextLink } from "@/components/site/Ui";
import { ExpertiseRows } from "@/components/home/Sections";
import Split, { Bullets } from "@/components/site/Split";
import { services } from "@/content/site";
import { useSeo } from "@/lib/seo";

const brandService = {
  n: "05", id: "identite-marque", title: "Identité & visuels de marque",
  text: "Logo, charte, packaging et visuels produits pour vos réseaux et votre site. Une image cohérente partout où l'on vous voit.",
  cta: "Voir l'univers Maison Sanaa", to: "/realisations/maison-sanaa#univers-de-marque",
};

export default function Expertises() {
  useSeo({
    title: "Expertises — sites, réservation, SEO local et Google",
    description: "Création de sites internet, réservation en ligne, référencement local et fiche Google Business Profile pour les commerces de Toulouse.",
    path: "/expertises",
  });
  return (
    <>
      <PageHero testid="expertises-hero" label="Expertises" lines={["Être trouvé, rassurer,", "faire appeler."]}
        intro="Un beau site qu'on ne trouve pas, ou une fiche Google qui mène à une page confuse : je travaille les deux ensemble." />
      <section className="wrap pb-14"><ExpertiseRows items={[...services, brandService]} /></section>
      <Split label="01 — Sites internet" title="Un site vitrine qui travaille pour vous.">
        <p>Sur mesure, rapide, pensé pour le téléphone. Carte ou prestations, galerie, accès, contact.</p>
        <TextLink to="/expertises/creation-site-internet" testid="detail-creation-link">Découvrir le service</TextLink>
      </Split>
      <Split label="02 — Référencement local" title="Être compris par Google.">
        <p>Mots-clés locaux, structure des pages, titres, métadonnées et contenus utiles.</p>
        <TextLink to="/referencement-local-toulouse" testid="detail-seo-link">Comprendre le référencement local</TextLink>
      </Split>
      <Split label="03 — Fiche Google" title="Une fiche Google complète et cohérente.">
        <Bullets items={["Catégories et description", "Services, photos, horaires", "Coordonnées identiques partout", "Liens vers le site et la réservation"]} />
      </Split>
      <Split id="detail-conversion" label="04 — Réservation et conversion" title="Moins de friction, plus de demandes.">
        <Bullets items={["Appel en un clic sur mobile", "Rendez-vous ou table en ligne", "Arrhes et agenda", "Suivi des clics et des formulaires"]} />
        <TextLink to="/tarifs" testid="detail-tarifs-link">Voir les formules</TextLink>
      </Split>
      <CtaBlock />
    </>
  );
}
